@if (!variant) {
  <ng-container *ngIf="type === 'flat'">
    <button
      mat-flat-button
      [matMenuTriggerFor]="matMenuTriggerFor"
      TSDebounceClick
      [allowBubbling]="allowBubbling"
      (debounceClick)="onClick($event)"
      [debounceTime]="debounceTime"
      [color]="color ?? 'primary'"
      [disabled]="disabled || loading"
      [attr.type]="htmlButtonType ?? null"
      [attr.tabindex]="tabIndex ?? null"
      class="ts-button icon-position-{{ iconPosition }}"
    >
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </button>
  </ng-container>

  <ng-container *ngIf="type === 'raised'">
    <button
      mat-raised-button
      [matMenuTriggerFor]="matMenuTriggerFor"
      TSDebounceClick
      [allowBubbling]="allowBubbling"
      (debounceClick)="onClick($event)"
      [debounceTime]="debounceTime"
      [color]="color ?? 'primary'"
      [disabled]="disabled || loading"
      [attr.type]="htmlButtonType ?? null"
      [attr.tabindex]="tabIndex ?? null"
      class="ts-button icon-position-{{ iconPosition }}"
    >
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </button>
  </ng-container>

  <ng-container *ngIf="type === 'stroked'">
    <button
      mat-stroked-button
      [matMenuTriggerFor]="matMenuTriggerFor"
      TSDebounceClick
      [allowBubbling]="allowBubbling"
      (debounceClick)="onClick($event)"
      [debounceTime]="debounceTime"
      [color]="color ?? 'primary'"
      [disabled]="disabled || loading"
      [attr.type]="htmlButtonType ?? null"
      [attr.tabindex]="tabIndex ?? null"
      class="ts-button icon-position-{{ iconPosition }}"
    >
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </button>
  </ng-container>

  <ng-container *ngIf="type === 'icon'">
    <button
      mat-icon-button
      [matMenuTriggerFor]="matMenuTriggerFor"
      TSDebounceClick
      [allowBubbling]="allowBubbling"
      (debounceClick)="onClick($event)"
      [debounceTime]="debounceTime"
      [color]="iconMatButtonColor"
      [disabled]="disabled || loading"
      [ngClass]="{ 'ts-button__icon-default': color == null }"
      [attr.type]="htmlButtonType ?? null"
      [attr.tabindex]="tabIndex ?? null"
      [matTooltip]="buttonTooltip || iconTooltip"
      [matTooltipDisabled]="!(buttonTooltip || iconTooltip)"
      [matTooltipPosition]="matTooltipPosition"
      [matTooltipShowDelay]="matTooltipShowDelay"
    >
      <ng-container *ngIf="lucideIcon">
        <lucide-icon
          [name]="icon"
          [size]="16"
          [color]="lucideStrokeColor ?? lucideIconStroke"
          [class]="iconCssClass"
        ></lucide-icon>
      </ng-container>
      <ng-container *ngIf="!lucideIcon && (icon || svgIcon)">
        <ts-icon [svgIconId]="svgIcon" [icon]="icon" [color]="iconColor" [class]="iconCssClass"></ts-icon>
      </ng-container>
      <!-- Same projection slot as text buttons (#buttonText); only one default ng-content may exist in the component. -->
      <ng-container [ngTemplateOutlet]="buttonText"></ng-container>
    </button>
  </ng-container>

  <ng-container *ngIf="type === 'fab'">
    <button
      mat-fab
      [matMenuTriggerFor]="matMenuTriggerFor"
      TSDebounceClick
      (debounceClick)="onClick($event)"
      [debounceTime]="debounceTime"
      [color]="color ?? 'primary'"
      [disabled]="disabled || loading"
      [attr.type]="htmlButtonType ?? null"
      [attr.tabindex]="tabIndex ?? null"
      class="ts-button icon-position-{{ iconPosition }}"
    >
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </button>
  </ng-container>
} @else {
  @switch (variant) {
    @case ('secondary') {
      <button
        TSDebounceClick
        [allowBubbling]="allowBubbling"
        mat-stroked-button
        class="bg-white ts-button icon-position-{{ iconPosition }}"
        color="accent"
        [debounceTime]="debounceTime"
        [matMenuTriggerFor]="matMenuTriggerFor"
        [ngClass]="{ 'bg-gray-200': disabled, active: active, 'cursor-not-allowed': disabled || loading }"
        [disabled]="disabled || loading"
        [attr.type]="htmlButtonType ?? null"
        [attr.tabindex]="tabIndex ?? null"
        (debounceClick)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }
    @case ('paginator') {
      @if (active) {
        <button
          TSDebounceClick
          mat-flat-button
          class="ts-button ts-button--paginator icon-position-{{ iconPosition }}"
          color="primary"
          [debounceTime]="debounceTime"
          [matMenuTriggerFor]="matMenuTriggerFor"
          [disabled]="disabled || loading"
          [attr.type]="htmlButtonType ?? null"
          [attr.tabindex]="tabIndex ?? null"
          (debounceClick)="onClick($event)"
        >
          <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
        </button>
      } @else {
        <button
          TSDebounceClick
          mat-stroked-button
          class="bg-white ts-button ts-button--paginator icon-position-{{ iconPosition }}"
          color="basic"
          [debounceTime]="debounceTime"
          [matMenuTriggerFor]="matMenuTriggerFor"
          [ngClass]="{ 'bg-gray-200': disabled }"
          [disabled]="disabled || loading"
          [attr.type]="htmlButtonType ?? null"
          [attr.tabindex]="tabIndex ?? null"
          (debounceClick)="onClick($event)"
        >
          <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
        </button>
      }
    }
    @case ('danger') {
      <button
        TSDebounceClick
        [allowBubbling]="allowBubbling"
        mat-flat-button
        class="ts-button icon-position-{{ iconPosition }}"
        color="warn"
        [debounceTime]="debounceTime"
        [matMenuTriggerFor]="matMenuTriggerFor"
        [ngClass]="{ active: active, 'cursor-not-allowed': disabled || loading }"
        [disabled]="disabled || loading"
        [attr.type]="htmlButtonType ?? null"
        [attr.tabindex]="tabIndex ?? null"
        (debounceClick)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }
    @case ('link') {
      <button
        TSDebounceClick
        [allowBubbling]="allowBubbling"
        type="button"
        class="ts-button ts-button--link icon-position-{{ iconPosition }}"
        [debounceTime]="debounceTime"
        [matMenuTriggerFor]="matMenuTriggerFor"
        [ngClass]="{ active: active }"
        [disabled]="disabled || loading"
        (debounceClick)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }
    @case ('dashed') {
      <button
        TSDebounceClick
        type="button"
        class="ts-button ts-button--dashed icon-position-{{ iconPosition }}"
        [debounceTime]="debounceTime"
        [matMenuTriggerFor]="matMenuTriggerFor"
        [ngClass]="{ active: active, 'cursor-not-allowed': disabled || loading }"
        [disabled]="disabled || loading"
        (debounceClick)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }
    @default {
      <button
        TSDebounceClick
        [allowBubbling]="allowBubbling"
        mat-flat-button
        class="ts-button icon-position-{{ iconPosition }}"
        color="primary"
        [debounceTime]="debounceTime"
        [matMenuTriggerFor]="matMenuTriggerFor"
        [ngClass]="{ active: active }"
        [disabled]="disabled || loading"
        [attr.type]="htmlButtonType ?? null"
        [attr.tabindex]="tabIndex ?? null"
        (debounceClick)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }
  }
}

<ng-template #buttonContent>
  <div
    class="flex flex-row flex-nowrap items-center whitespace-nowrap h-full"
    [ngClass]="variant === 'paginator' ? 'justify-center gap-1' : 'justify-between gap-2'"
  >
    @if (loading) {
      <mat-spinner
        diameter="16"
        class="mr-2"
        [strokeWidth]="2"
        mode="indeterminate"
        [color]="color ?? 'primary'"
      ></mat-spinner>
      <ng-container [ngTemplateOutlet]="buttonText"></ng-container>
    } @else {
      @if (icon) {
        @if (lucideIcon) {
          <lucide-icon [name]="icon" [size]="16" [color]="lucideStrokeColor ?? 'black'" [class]="iconCssClass" />
        } @else {
          <ts-icon [icon]="icon" [color]="iconColor" />
        }
      }
      <ng-container [ngTemplateOutlet]="buttonText"></ng-container>
      @if (menuIcon) {
        <div
          class="icon-position-suffix__container"
          [ngClass]="{
            'icon-position-suffix__container--secondary': variant === 'secondary' || variant === 'paginator',
          }"
        >
          <ts-icon icon="keyboard_arrow_down" [color]="iconColor"></ts-icon>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #buttonText>
  <ng-content></ng-content>
</ng-template>
